import { ChangeDetectionStrategy, Component, OnDestroy, OnInit, ViewChild } from '@angular/core';
import { Router } from '@angular/router';
import { BaseComponent } from '@app/shared/base-components/base.component';
import { ContextMenuService } from '@app/shared/context-menu/context-menu.service';
import { ContextMenu, ContextMenuModule } from 'primeng/contextmenu';
import { fromEvent, merge, takeUntil } from 'rxjs';

@Component({
	selector: 'context-menu',
	imports: [
		ContextMenuModule
	],
	templateUrl: './context-menu.component.html',
	changeDetection: ChangeDetectionStrategy.OnPush
})
export class ContextMenuComponent extends BaseComponent implements OnInit, OnDestroy {

	@ViewChild(ContextMenu)
	contextMenu: ContextMenu;

	constructor (
		private readonly contextMenuService: ContextMenuService,
		private readonly router: Router
	) {
		super();
	}

	ngOnInit (): void {
		this.subscribeToContextMenuService();
		this.subscribeToNavigateAway();
	}

	private subscribeToContextMenuService () {
		this.contextMenuService
			.contextMenu$
			.pipe(
				takeUntil(this.isDestroyed)
			)
			.subscribe(({ event, model }) => {
				this.contextMenu.model = model;
				this.contextMenu.show(event);
			});
	}

	private subscribeToNavigateAway () {
		merge(
			this.router.events,
			fromEvent(window, 'blur')
		)
			.pipe(
				takeUntil(this.isDestroyed)
			)
			.subscribe(() => this.contextMenu?.hide());
	}
}
